module.exports = __webpack_public_path__ + "static/media/Layer1.0582a338.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Layer1.png
// module id = 53
// module chunks = 0